import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ProductService } from 'src/app/services/product.service';
import { SecurityService } from 'src/app/services/security.service';


@Component({
  selector: 'app-producttimeline',
  templateUrl: './producttimeline.component.html',
  styleUrls: ['./producttimeline.component.scss']
})
export class ProducttimelineComponent implements OnInit  {
  productTimeLineList: any[];
  color: string;
  id: any;
  routeParams: any;
 

  constructor(private productService: ProductService,
    private securityService: SecurityService,
    route: ActivatedRoute) {
    this.routeParams = route.snapshot.params;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
  }

  ngOnInit(): void {
    this.getproductTimeLine(true);
  }

  approvedStatusColor(statusType: number) {
    switch (statusType) {
      case 1:
        return '#10B759'
      case 2:
        return '#800080'
      case 3:
        return '#D80F0F'
      case 4:
        return '#3F67A7'
      case 5:
        return '#F74040'
    }
  }

  getproductTimeLine(refresh: boolean) {
    this.productTimeLineList = [];
    this.productService
      .getProductTimeLine(this.id, refresh)
      .subscribe((result) => {
        if (result) {
          this.productTimeLineList = result;
          this.productTimeLineList.forEach(s =>
            s.eventTs = moment(s.eventTs).format('DD-MM-YYYY')
          )
        }
      });
  }
}
